import { Card, Typography, theme, Row, Button } from "antd";
import { ProgramCard } from "./Sections.default";
import { useState, useEffect } from "react";

const { Title, Paragraph, Text } = Typography;

//////////////////////////////////
// TODO: Replace with actual data
const programs: ProgramCard[] = [
  {
    title: "GYM Membership",
    location: "New York, USA",
    description:
      "This is prime space! Use it to elaborate on your attention-grabbing section title. Explain what this section is about, share some details, and give just the right amount of information to get the audience hooked.",
    backgroundColor: "bg-red-100",
  },
  {
    title: "Online Yoga courses",
    location: "Online",
    description:
      "This is prime space! Use it to elaborate on your attention-grabbing section title. Explain what this section is about, share some details, and give just the right amount of information to get the audience hooked.",
    backgroundColor: "bg-green-100",
  },
  {
    title: "Free diagnostic visit to X medical Center",
    location: "Lithuania",
    description:
      "This is prime space! Use it to elaborate on your attention-grabbing section title. Explain what this section is about, share some details, and give just the right amount of information to get the audience hooked.",
    backgroundColor: "bg-yellow-100",
  },
  {
    title: "Mental Health Workshop",
    location: "Remote",
    description:
      "This is prime space! Use it to elaborate on your attention-grabbing section title. Explain what this section is about, share some details, and give just the right amount of information to get the audience hooked.",
    backgroundColor: "bg-purple-100",
  },
  {
    title: "Nutrition Consultation",
    location: "Paris, France",
    description:
      "This is prime space! Use it to elaborate on your attention-grabbing section title. Explain what this section is about, share some details, and give just the right amount of information to get the audience hooked.",
    backgroundColor: "bg-blue-100",
  },
];
/////////////////////////////////

function SectionTwo() {
  const { token } = theme.useToken();
  const [isExpanded, setIsExpanded] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Update window width when resizing
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Get number of cards to show based on screen size
  const getVisibleCardCount = () => {
    if (windowWidth < 768) return 1;
    if (windowWidth < 1024) return 2;
    return 3;
  };

  // First N programs and remaining programs
  const mainPrograms = programs.slice(0, getVisibleCardCount());
  const additionalPrograms = programs.slice(getVisibleCardCount());

  const renderProgramCards = (programs: ProgramCard[]) => (
    <Row
      justify="center"
      className="grid grid-cols-1 gap-x-4 gap-y-8 px-0 sm:grid-cols-1 sm:px-4 md:grid-cols-2 lg:grid-cols-3"
    >
      {programs.map((program, index) => (
        <ProgramCardComponent key={index} program={program} />
      ))}
    </Row>
  );

  return (
    <section className="mx-auto max-w-[1920px] px-4 py-8 sm:px-8 lg:px-16 lg:py-16">
      {/* Headers */}
      <div className="mx-auto mb-8 max-w-2xl text-center lg:mb-16">
        <SectionTitle title="Latest Updates" />
        <SectionTitle title="Well-Being Programs" />
      </div>

      {/* Main Programs */}
      <div className="flex flex-col items-center">
        {renderProgramCards(mainPrograms)}

        {/* Additional Programs  */}
        {additionalPrograms.length > 0 && (
          <div className="relative mt-8 w-full">
            <div
              className={`transform-gpu transition-all duration-700 ease-in-out ${
                isExpanded
                  ? "max-h-[2000px] scale-y-100 opacity-100"
                  : "max-h-0 origin-top scale-y-95 overflow-hidden opacity-0"
              }`}
              style={{
                transformOrigin: "top",
                willChange: "transform, opacity, max-height",
              }}
            >
              {renderProgramCards(additionalPrograms)}
            </div>

            <div className="flex justify-end">
              <button
                onClick={() => setIsExpanded(!isExpanded)}
                className={`relative mt-2 flex items-center gap-2 rounded-full border-none bg-white px-6 py-2 text-base shadow-md outline-none transition-all duration-700 ease-in-out hover:bg-gray-50 focus:outline-none ${
                  isExpanded ? "translate-y-8" : ""
                }`}
                style={{ color: token.colorPrimary }}
              >
                {isExpanded ? "Show Less" : "View More Programs"}
                <span
                  className={`transform transition-transform duration-500 ease-in-out ${
                    isExpanded ? "rotate-180" : ""
                  }`}
                >
                  ▼
                </span>
              </button>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

// Title Component
function SectionTitle({ title }: { title: string }) {
  const { token } = theme.useToken();
  return (
    <Row align="middle" justify="center">
      <Title
        level={2}
        className="mb-2 text-2xl lg:mb-4 lg:text-4xl"
        style={{ color: token.colorPrimary, fontFamily: token.fontFamily }}
      >
        {title}
      </Title>
    </Row>
  );
}

// Card Component
function ProgramCardComponent({ program }: { program: ProgramCard }) {
  const { token } = theme.useToken();
  return (
    <Card
      className={`relative h-full max-w-[300px] transition-all hover:shadow-lg ${program.backgroundColor}`}
      style={{ borderColor: token.colorBorder }}
    >
      <div className="flex h-full flex-col pb-12">
        <div>
          <Title
            level={4}
            className="mb-2 text-base sm:text-lg lg:text-xl"
            style={{
              color: token.colorPrimary,
              fontFamily: token.fontFamily,
            }}
          >
            {program.title}
          </Title>
          <Text
            type="secondary"
            className="mb-2 block text-sm lg:mb-4 lg:text-base"
            style={{ fontFamily: token.fontFamily }}
          >
            Location: {program.location}
          </Text>
          <Paragraph
            className="mb-2 text-sm lg:text-base"
            style={{
              color: token.colorPrimary,
              fontFamily: token.fontFamily,
            }}
          >
            {program.description}
          </Paragraph>
        </div>

        <div className="absolute bottom-3 left-0 right-0 flex justify-center">
          <Button
            type="default"
            className="rounded-full border-none bg-white px-6 py-2 text-sm shadow-md outline-none transition-all hover:bg-gray-50 focus:outline-none"
            style={{ color: token.colorPrimary }}
          >
            More
          </Button>
        </div>
      </div>
    </Card>
  );
}

export default SectionTwo;
